module.exports = require("./zh-Hant");